module.exports = __webpack_public_path__ + "fonts/PFBeauSansPro-Bold.4d224981.ttf";